import React from "react";
import { formatDisplayValue, isValidNumber } from "../utility/quickViewMapper";

/**
 * Renders one period's value cell. The unit is intentionally omitted here -
 * it is shown once beside the question title instead.
 *
 * @param {Object} props
 * @param {{value: *, unit: string}} [props.cell] - Cell data; absent renders "No Answer".
 * @returns {JSX.Element} A table cell.
 */
const QuickViewCell = ({ cell }) => {
  const displayValue = formatDisplayValue(cell?.value);

  let variant = "qv-cell--text";
  if (displayValue === "No Answer") variant = "qv-cell--empty";
  else if (isValidNumber(cell?.value)) variant = "qv-cell--number";

  return <td className={`qv-td qv-cell ${variant}`}>{displayValue}</td>;
};

export default QuickViewCell;
